import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  Divider,
  MenuItem,
} from "@mui/material";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import { useState, useEffect } from "react";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ReportService from "src/service/reports";
import * as XLSX from "xlsx";
import { IconFileDownload } from "@tabler/icons";
import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import RouteAllotmentService from "src/service/routeAllotmentToVehicle";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Vehicle Route Allotment Report",
  },
];

const VehicleRouteAllotmentReport = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [routeallotment, setrouteallotment] = useState([]);
  // const [device_name, setDevice_name] = useState([]);
  // const [selectedDevice, setSelectedDevice] = useState("");
  const [vehicle_list, setvehicleList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");

  // const handleDeviceChange = (event) => {
  //   setSelectedDevice(event.target.value);
  // };

  // const filteredData = routeallotment.filter((item) => {
  //   if (!selectedDevice || item.imei_no === selectedDevice) {
  //     return true;
  //   }
  //   return false;
  // });

  const fetchVehicleNoData = async () => {
    try {
      const res = await RouteAllotmentService.getVehicleNoList({});
      setvehicleList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const filteredData = routeallotment.filter((item) => {
    return selectedVehicle ? item.vehicle_no === selectedVehicle : true;
  });

  // const fetchDeviceData = async () => {
  //   try {
  //     const res = await ReportService.getDevicelistforInstallation({
  //       // manufacturer_id: sessionData.data.id,
  //
  //     });
  //     setDevice_name(res.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchrouteallotmentData = async () => {
    try {
      const res = await ReportService.getvehiclerouteallotmentDetails({
        // vehicle_no: '',
      });

      setrouteallotment(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchrouteallotmentData();
    fetchVehicleNoData();
    // fetchDeviceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  // ============== export in excel start ===========================
  const exportVisibleDataToExcel = () => {
    const table = document.getElementById("allotment_report_table");
    if (!table) {
      alert("Table not found");
      return;
    }

    const rows = [];

    for (let i = 0; i < table.rows.length; i++) {
      const row = [];
      const currentRow = table.rows[i];

      for (let j = 0; j < currentRow.cells.length; j++) {
        const cell = currentRow.cells[j];
        row.push(cell.textContent);
      }

      rows.push(row);
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rows);

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, { type: "binary", bookType: "xlsx" });

    const fileName = "Route Allotment Report.xlsx";
    const dataBlob = new Blob([s2ab(wbout)], {
      type: "application/octet-stream",
    });

    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };
  // ============== export in excel ends ============================
  return (
    <PageContainer
      title="Route Allotment"
      description="this is Basic Table page"
    >
      <Breadcrumb title="Vehicle Route Allotment Report" items={BCrumb} />

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Vehicle Route Allotment Report
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={exportVisibleDataToExcel}
            >
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center" style={{ marginTop: "10px" }}>
          <Grid
            item
            container
            xs={12}
            style={{ paddingBottom: "20px" }}
            alignItems="center"
            spacing={2}
          >
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel>
                Vehicle No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomSelect
                id="vehicle_no"
                name="vehicle_no"
                fullWidth
                variant="outlined"
                value={selectedVehicle}
                onChange={(event) => setSelectedVehicle(event.target.value)}
              >
                <MenuItem value=""> Select Vehicle No </MenuItem>
                {vehicle_list.map((option) => (
                  <MenuItem key={option.vehicle_no} value={option.vehicle_no}>
                    {option.vehicle_no}
                  </MenuItem>
                ))}
              </CustomSelect>
            </Grid>
          </Grid>
        </Grid>
        <Paper variant="outlined">
          <TableContainer>
            <Table
              id="allotment_report_table"
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "silver" }}>
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Route Name
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4}>
                      <Typography
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          color: "red",
                        }}
                        variant="h6"
                      >
                        No records found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData.map((item, index) => (
                    <TableRow key={item.id}>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {index + 1}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.vehicle_no !== null ? item.vehicle_no : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.route_name !== null ? item.route_name : "NA"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </ParentCard>
    </PageContainer>
  );
};

export default VehicleRouteAllotmentReport;
